import { render, staticRenderFns } from "./ComparisonBlock.vue?vue&type=template&id=0e30db51&"
import script from "./ComparisonBlock.vue?vue&type=script&lang=js&"
export * from "./ComparisonBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiLazyImg: require('/app/components/UI/UiLazyImg.vue').default})
